import axios from "axios";
const API_URL = "api/admin";

const adminLogin = async (adminDetails) => {
  const response = await axios.post(API_URL + "/login", adminDetails);
  //   (response.data)
  if (response.data) {
    localStorage.setItem("admin", JSON.stringify(response.data));
  }
  return response.data;
};

const adminLogout = () => {
  localStorage.removeItem("admin");
};
const adminServices = {
  adminLogin,
  adminLogout,
};

export default adminServices;
